<template>
  <div class="header pt3-ns">
    <div>
      <div class="nav flex justify-between items-center pa05-m">
        <div class="nav__logo">
          <router-link class="logo link fw6 pa2s ttc flex items-center" :to="{name: 'home'}">
            <img class="logo__img" v-bind:src="logoUrl">
            <span class="logo__text">{{siteName}}</span>
          </router-link>
        </div>

        <div class="nav__links tr">
          <div class="pt3-l pt0-m pt0-l language-component">
            <component v-bind:is="languageDropdownComponent"></component>
          </div>

          <div class="pt3 mt1 header-links">
            <a :href="loginLink" class="black-link fw7 pa2 fs14 header-link">{{$t('loginLinkText')}}</a>
            <a
              :href="signupLink"
              class="black-link fw7 pa2 fs14 ml02 header-link hl2"
            >{{$t('signupLinkText')}}</a>
          </div>
        </div>
      </div>

      <div class="stage mt1">
        <div class="row-container page-head">
          <h1 class="stage__title">{{$t('headerTitle')}}</h1>
          <h5 class="stage_title--sub">{{$t('vpnHeaderTitleDescription')}}</h5>
        </div>
        <component v-bind:is="searchBarComponent"></component>
        <div class="row-container">
          <p class="stage__text">
            <span
              class="stage__text__question text--theme-highlight fw6"
            >{{$t('incorrectPopularQuestion')}}:</span>
            <router-link
              class="link fw4"
              :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[3]}-${popularQuestionThree.title.replace(/ /g, '-')}`}"
            >{{$t('popQues5')}}</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getComponent, getSpecificArticleFromStore } from '@/utils/common';
export default {
  data: () => {
    return {
      showMembersBar: false
    };
  },
  computed: {
    languageDropdownComponent() {
      return getComponent(this.$store.getters.flowObject, 'languageDropdown');
    },
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    loginLink() {
      return `https://${this.$store.state.siteDetails.domain_name}/login`;
    },
    MALink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}`;
    },
    signupLink() {
      return `https://${this.$store.state.siteDetails.domain_name}/signup`;
    },
    logoUrl() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/${this.siteName.toLowerCase().replace(' ', '')}/favicon.ico`
    },
    popularQuestionOne() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[0]);
      return question || { title: '' };
    },
    popularQuestionTwo() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[1]);
      return question || { title: '' };
    },
    popularQuestionThree() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[3]);
      return question || { title: '' };
    },
    searchBarComponent() {
      return getComponent(this.$store.getters.flowObject, 'searchBar');
    }
  }
};
</script>

<style lang="scss" scoped>
.nav {
  max-width: 1160px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
// Remove this when we want to return to normal DOM flow...
.nav__links {
  position: relative;
  top: 1rem;
  padding-right: 0.4rem;
}
// end of removal
.pa2s {
  padding: 0.5rem 0.7rem 0.7rem 0.7rem;
}
.logo__img {
  max-width: 30px;
  padding-left: 0.1rem;
  padding-bottom: 0.3rem;
}
.logo__text {
  font-size: 19.5px;
  font-weight: 400;
  margin-left: 1.5rem;
}
.language-component {
  margin-top: 0.35rem;
}
.header-links {
  margin-top: 0.65rem;
  margin-right: 0.25rem;
}
.black-link {
  color: #2b2b2b;
  text-decoration: none;
}
.black-link:hover {
  opacity: 0.8;
}
.ml02 {
  margin-left: 0.2rem;
}
.fs14 {
  font-size: 14.4px;
}
.stage {
  text-align: center;
  .link:hover {
    text-decoration: underline;
  }
}
.stage__title {
  font-size: 23px;
  font-family: 'Avenir Next', sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 1.26px;
  margin-bottom: 0.4rem;
  padding-top: 0.8rem;
  color: #2b2b2b;
}
.stage_title--sub {
  font-size: 13px;
  font-family: 'Avenir Next Regular', sans-serif;
  font-weight: 400;
  margin: 0;
  margin-bottom: 2.9rem;
  color: #8c8c8c;
}
.stage__text {
  padding-left: 1rem;
  padding-right: 1rem;
  margin-top: 1.75rem;
  font-size: 0.875rem;
  .link {
    color: black;
  }
  .stage__text__question {
    display: block;
  }
}
@media (min-width: 426px) {
  .logo__text {
    font-size: 25.5px;
  }
}
@media (min-width: 641px) {
  .header {
    margin-bottom: 1rem;
  }
  .nav {
    padding: 0 5%;
    height: 75px;
  }
  .stage__title {
    font-size: 42px;
  }
  .stage__text {
    font-size: 1rem;
    margin-top: 1.2rem;
    .stage__text__question {
      display: inline;
    }
  }
}
@media (min-width: 641px) and (max-width: 832px) {
  .stage__title {
    font-size: 23px;
    letter-spacing: 0.69px;
  }
  .router-link-active {
    flex-direction: column;
  }
  .nav {
    flex-direction: column;
    height: 100%;
  }
  .nav__links {
    top: 0;
  }
  .language-component {
    margin: 0;
  }
  .pa2s {
    padding-bottom: 0;
  }
  .header-links {
    margin-right: 0;
  }
  .stage_title--sub {
    margin-bottom: 1.5rem;
  }
  .hl2 {
    padding-right: 0;
  }
  .logo__text {
    margin-left: 0;
  }
  .header {
    margin-bottom: 2.5rem;
  }
}
@media (min-width: 832px) {
  .header {
    margin-bottom: 6.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .stage__title {
    padding-top: 0;
    margin-top: -1.7rem;
  }
  .stage_title--sub {
    margin-top: 1.85rem;
    margin-bottom: 1.3rem;
    font-size: 18px;
  }
  .stage__text {
    margin-top: 1rem;
  }
  .page-head {
    margin-top: 20px;
  }
}
@media (min-width: 960px) {
  .header {
    margin-bottom: 6.5rem;
  }
  .nav {
    max-width: 70em;
    padding: 0 0.5rem;
  }
}
@media (max-width: 650px) {
  .pa05-m {
    padding: 0 5px 10px 20px;
    margin-top: 8px;
  }
  .logo__text {
    margin-left: 0.5rem;
  }
  .language-component {
    margin-top: 1rem;
  }
  .header-links {
    margin-right: 2rem;
  }
  .stage {
    padding: 0 15px;
  }
  .stage__text {
    margin-top: 28px;
    margin-bottom: 28px;
    padding-right: 0;
    padding-left: 0;
  }
  .header-links {
    margin-top: 0;
  }
  .pa2s {
    padding: 0.9rem 0.7rem 0.7rem 0.7rem;
  }
}
@media (max-width: 320px) {
  .pa05-m {
    margin-top: 0;
    padding-bottom: 5px;
    padding-top: 5px;
    padding-left: 26px;
  }
  .logo__text {
    margin: 0;
    margin-left: -2px;
  }
  .header-links {
    flex-direction: row;
    display: flex;
    padding-top: 10px;
    margin-left: -8px;
  }
  .language-component {
    margin-top: 1.6rem;
  }
  .pa2s {
    padding-left: 0;
  }
}
</style>
